// extracted by mini-css-extract-plugin
module.exports = {"clientStats":"_c9fc5b5","playersCount":"_4ca48ed","tournamentsCount":"_f511594","statsNumber":"_2aadeea"};